var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step3-container" }, [
    _vm.form.pricings.length
      ? _c(
          "div",
          { staticClass: "step" },
          _vm._l(_vm.form.pricings, function(pricing, index) {
            return _c("camp-pricing-end", {
              key: index,
              staticClass: "camp-pricing",
              attrs: { pricing: pricing, "new-pricing": pricing.new },
              on: {
                "input:price": function($event) {
                  return _vm.setPricingPrice({ price: $event, id: pricing.id })
                },
                "input:wait-list": function($event) {
                  return _vm.setPricingWaitList({
                    waitList: $event,
                    id: pricing.id
                  })
                },
                "input:max-wait-list": function($event) {
                  return _vm.setPricingMaxWaitList({
                    maxWaitList: $event,
                    id: pricing.id
                  })
                },
                "input:max-enroll": function($event) {
                  return _vm.setPricingMaxEnroll({
                    maxEnroll: $event,
                    id: pricing.id
                  })
                },
                "input:billing-type": function($event) {
                  return _vm.setPricingBillingType({
                    billingType: $event,
                    id: pricing.id
                  })
                },
                "input:paid": function($event) {
                  return _vm.setPricingPaid({ paid: $event, id: pricing.id })
                }
              }
            })
          }),
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasAtLeastOnePaidPricing
      ? _c(
          "div",
          {
            staticClass: "step",
            class: {
              "step-closed": !_vm.discountsOpened,
              disabled: _vm.isCampCostEditingDisabled
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-between align-items-center"
              },
              [
                _c("h2", [_vm._v("Are there any discounts?")]),
                _vm._v(" "),
                _c("switch-button", {
                  attrs: {
                    id: "discount-opened",
                    checked: _vm.discountsOpened
                  },
                  on: {
                    "update:checked": function($event) {
                      _vm.discountsOpened = $event
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.detectIE
              ? [
                  _c("transition", { attrs: { name: "expand" } }, [
                    _vm.discountsOpened
                      ? _c("div", { staticClass: "mg-top-40" }, [
                          _c("div", { staticClass: "d-flex" }, [
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("switch-button", {
                                  attrs: {
                                    id: "early-bird-discount-active-ie",
                                    label: "Early bird",
                                    checked: _vm.earlyBirdActive
                                  },
                                  on: {
                                    "update:checked": function($event) {
                                      _vm.earlyBirdActive = $event
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("select-box", {
                                  key: "earlyBirdBonusType",
                                  attrs: {
                                    label: "Type",
                                    placeholder: "Select $ or %",
                                    disabled: !_vm.earlyBirdActive,
                                    "default-value":
                                      _vm.form.earlyBirdDiscount &&
                                      _vm.form.earlyBirdDiscount.bonusType,
                                    required:
                                      _vm.form.earlyBirdDiscount &&
                                      _vm.form.earlyBirdDiscount.active &&
                                      _vm.discountsOpened,
                                    "data-list": Object.values(
                                      _vm.BONUS_PAYMENTS_TYPES
                                    )
                                  },
                                  on: { selected: _vm.setEarlyBirdBonusType }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("app-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.form.earlyBirdDiscount &&
                                          _vm.form.earlyBirdDiscount.active &&
                                          _vm.discountsOpened,
                                        percentage:
                                          _vm.form.earlyBirdDiscount &&
                                          _vm.form.earlyBirdDiscount
                                            .bonusType ===
                                            _vm.BONUS_PAYMENTS_TYPES.RELATIVE,
                                        max: 15,
                                        decimal: 2,
                                        "bigger-or-equal": 0.01
                                      },
                                      expression:
                                        "{\n                                             required: form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened,\n                                             percentage:  form.earlyBirdDiscount && form.earlyBirdDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,\n                                             max: 15,\n                                             decimal: 2,\n                                            'bigger-or-equal': 0.01\n                                       }"
                                    }
                                  ],
                                  key: "earlyBirdAmount",
                                  attrs: {
                                    id: "earlyBirdAmount-ie",
                                    label: "Amount Off",
                                    placeholder: "15",
                                    disabled: !_vm.earlyBirdActive,
                                    "min-width": 100,
                                    name: "earlyBirdAmount",
                                    type: "text"
                                  },
                                  model: {
                                    value: _vm.earlyBirdAmount,
                                    callback: function($$v) {
                                      _vm.earlyBirdAmount = $$v
                                    },
                                    expression: "earlyBirdAmount"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("date-picker", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.form.earlyBirdDiscount &&
                                          _vm.form.earlyBirdDiscount.active &&
                                          _vm.discountsOpened,
                                        "future-date": !_vm.validateCampEarlyBirdDiscountExeption
                                      },
                                      expression:
                                        "{\n                                            required: form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened,\n                                             'future-date': !validateCampEarlyBirdDiscountExeption\n                                             }"
                                    }
                                  ],
                                  key: "earkyBirdEnds",
                                  staticClass:
                                    "discount-right-tooltiptext-ends",
                                  attrs: {
                                    id: "ends-ie",
                                    info:
                                      "Select last date the discount is available",
                                    name: "earlyBirdEnds",
                                    "min-width": 100,
                                    disabled: !_vm.earlyBirdActive,
                                    label: "Ends"
                                  },
                                  model: {
                                    value: _vm.earlyBirdEndDate,
                                    callback: function($$v) {
                                      _vm.earlyBirdEndDate = $$v
                                    },
                                    expression: "earlyBirdEndDate"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "position-relative" },
                                  [
                                    _vm.futureDate(_vm.earlyBirdEndDate)
                                      ? _c("div", { staticClass: "error" }, [
                                          _vm._v("Should be future date")
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("switch-button", {
                                  attrs: {
                                    id: "multi-program-discount-active-ie",
                                    label: "Multi program",
                                    checked: _vm.multiProgramDiscountActive
                                  },
                                  on: {
                                    "update:checked": function($event) {
                                      _vm.multiProgramDiscountActive = $event
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("select-box", {
                                  key: "multiProgram",
                                  attrs: {
                                    label: "Type",
                                    placeholder: "Select $ or %",
                                    disabled: !_vm.multiProgramDiscountActive,
                                    "default-value":
                                      _vm.form.multiProgramDiscount &&
                                      _vm.form.multiProgramDiscount.bonusType,
                                    "data-list": Object.values(
                                      _vm.BONUS_PAYMENTS_TYPES
                                    ),
                                    required:
                                      _vm.form.multiProgramDiscount &&
                                      _vm.form.multiProgramDiscount.active
                                  },
                                  on: {
                                    selected:
                                      _vm.setMultiProgramDiscountBonusType
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("app-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.form.multiProgramDiscount &&
                                          _vm.form.multiProgramDiscount.active,
                                        percentage:
                                          _vm.form.multiProgramDiscount &&
                                          _vm.form.multiProgramDiscount
                                            .bonusType ===
                                            _vm.BONUS_PAYMENTS_TYPES.RELATIVE,
                                        max: 15,
                                        decimal: 2,
                                        "bigger-or-equal": 0.01
                                      },
                                      expression:
                                        "{\n                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,\n                                            percentage: form.multiProgramDiscount && form.multiProgramDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,\n                                            max: 15,\n                                            decimal: 2,\n                                            'bigger-or-equal': 0.01\n                                       }"
                                    }
                                  ],
                                  key: "multiProgramDiscount",
                                  attrs: {
                                    id: "multiProgramDiscount-ie",
                                    placeholder: "15",
                                    disabled: !_vm.multiProgramDiscountActive,
                                    "min-width": 100,
                                    name: "multiProgramAmount",
                                    label: "Amount Off",
                                    type: "text"
                                  },
                                  model: {
                                    value: _vm.multiProgramDiscountAmount,
                                    callback: function($$v) {
                                      _vm.multiProgramDiscountAmount = $$v
                                    },
                                    expression: "multiProgramDiscountAmount"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("app-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.form.multiProgramDiscount &&
                                          _vm.form.multiProgramDiscount.active,
                                        numeric: true,
                                        max: 9
                                      },
                                      expression:
                                        "{\n                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,\n                                            numeric: true,\n                                            max: 9\n                                            }"
                                    }
                                  ],
                                  key: "multiProgramAfter",
                                  staticClass: "discount-right-tooltiptext",
                                  attrs: {
                                    id: "multiProgramAfter-ie",
                                    info:
                                      "Enter the number of camps a child <br> must be enrolled in to receive the discount",
                                    placeholder: "2",
                                    disabled: !_vm.multiProgramDiscountActive,
                                    "min-width": 100,
                                    name: "multiProgramNumberOfKids",
                                    label: "Discount After",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.multiProgramDiscountNumberOfKids,
                                    callback: function($$v) {
                                      _vm.multiProgramDiscountNumberOfKids = $$v
                                    },
                                    expression:
                                      "multiProgramDiscountNumberOfKids"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("switch-button", {
                                  attrs: {
                                    label: "Multi child",
                                    id: "multi-child-discount-active-ie",
                                    checked: _vm.multiChildDiscountActive
                                  },
                                  on: {
                                    "update:checked": function($event) {
                                      _vm.multiChildDiscountActive = $event
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "discount-row-item" }, [
                              _c(
                                "div",
                                { staticClass: "mt-auto" },
                                [
                                  _c("select-box", {
                                    key: "multiChildDiscount",
                                    attrs: {
                                      label: "Type",
                                      placeholder: "Select $ or %",
                                      disabled: !_vm.multiChildDiscountActive,
                                      "default-value":
                                        _vm.form.multiChildDiscount &&
                                        _vm.form.multiChildDiscount.bonusType,
                                      "data-list": Object.values(
                                        _vm.BONUS_PAYMENTS_TYPES
                                      ),
                                      required:
                                        _vm.form.multiChildDiscount &&
                                        _vm.form.multiChildDiscount.active &&
                                        _vm.discountsOpened
                                    },
                                    on: {
                                      selected:
                                        _vm.setMultiChildDiscountBonusType
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("app-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.form.multiChildDiscount &&
                                          _vm.form.multiChildDiscount.active &&
                                          _vm.discountsOpened,
                                        percentage:
                                          _vm.form.multiChildDiscount &&
                                          _vm.form.multiChildDiscount
                                            .bonusType ===
                                            _vm.BONUS_PAYMENTS_TYPES.RELATIVE,
                                        max: 15,
                                        decimal: 2,
                                        "bigger-or-equal": 0.01
                                      },
                                      expression:
                                        "{\n                                            required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,\n                                            percentage: form.multiChildDiscount && form.multiChildDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,\n                                            max: 15,\n                                            decimal: 2,\n                                            'bigger-or-equal': 0.01\n                                       }"
                                    }
                                  ],
                                  key: "multiChildDiscountAmount",
                                  attrs: {
                                    id: "siblingAmount-ie",
                                    placeholder: "15",
                                    disabled: !_vm.multiChildDiscountActive,
                                    "min-width": 100,
                                    name: "siblingAmount",
                                    label: "Amount Off",
                                    type: "text"
                                  },
                                  model: {
                                    value: _vm.multiChildDiscountAmount,
                                    callback: function($$v) {
                                      _vm.multiChildDiscountAmount = $$v
                                    },
                                    expression: "multiChildDiscountAmount"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "discount-row-item" },
                              [
                                _c("app-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required:
                                          _vm.form.multiChildDiscount &&
                                          _vm.form.multiChildDiscount.active &&
                                          _vm.discountsOpened,
                                        numeric: true,
                                        max: 9
                                      },
                                      expression:
                                        "{\n                                                required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,\n                                                numeric: true,\n                                                max:9\n                                                }"
                                    }
                                  ],
                                  key: "multiChildDiscountAfter",
                                  staticClass: "discount-right-tooltiptext",
                                  attrs: {
                                    id: "after-ie",
                                    placeholder: "2",
                                    info:
                                      "Enter the number of children that need to be<br> enrolled in this camp to receive the discount.",
                                    disabled: !_vm.multiChildDiscountActive,
                                    "min-width": 100,
                                    name: "siblingNumberOfKids",
                                    label: "Discount After",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.multiChildDiscountNumberOfKids,
                                    callback: function($$v) {
                                      _vm.multiChildDiscountNumberOfKids = $$v
                                    },
                                    expression: "multiChildDiscountNumberOfKids"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ]
              : [
                  _c(
                    "transition",
                    {
                      attrs: { name: "expand" },
                      on: {
                        enter: _vm.onEnter,
                        "after-enter": _vm.onAfterEnter,
                        leave: _vm.onLeave
                      }
                    },
                    [
                      _vm.discountsOpened
                        ? _c("div", { staticClass: "mg-top-40" }, [
                            _c("div", { staticClass: "discount-wrapper" }, [
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("switch-button", {
                                    attrs: {
                                      id: "early-bird-discount-active",
                                      label: "Early bird",
                                      checked: _vm.earlyBirdActive
                                    },
                                    on: {
                                      "update:checked": function($event) {
                                        _vm.earlyBirdActive = $event
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("select-box", {
                                    key: "earlyBirdBonusType",
                                    attrs: {
                                      label: "Type",
                                      placeholder: "Select $ or %",
                                      disabled: !_vm.earlyBirdActive,
                                      "default-value":
                                        _vm.form.earlyBirdDiscount &&
                                        _vm.form.earlyBirdDiscount.bonusType,
                                      required:
                                        _vm.form.earlyBirdDiscount &&
                                        _vm.form.earlyBirdDiscount.active &&
                                        _vm.discountsOpened,
                                      "data-list": Object.values(
                                        _vm.BONUS_PAYMENTS_TYPES
                                      )
                                    },
                                    on: { selected: _vm.setEarlyBirdBonusType }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("app-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            _vm.form.earlyBirdDiscount &&
                                            _vm.form.earlyBirdDiscount.active &&
                                            _vm.discountsOpened,
                                          percentage:
                                            _vm.form.earlyBirdDiscount &&
                                            _vm.form.earlyBirdDiscount
                                              .bonusType ===
                                              _vm.BONUS_PAYMENTS_TYPES.RELATIVE,
                                          max: 15,
                                          decimal: 2,
                                          "bigger-or-equal": 0.01
                                        },
                                        expression:
                                          "{\n                                             required: form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened,\n                                             percentage:  form.earlyBirdDiscount && form.earlyBirdDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,\n                                             max: 15,\n                                             decimal: 2,\n                                            'bigger-or-equal': 0.01\n                                       }"
                                      }
                                    ],
                                    key: "earlyBirdAmount",
                                    attrs: {
                                      id: "earlyBirdAmount",
                                      label: "Amount Off",
                                      placeholder: "15",
                                      disabled: !_vm.earlyBirdActive,
                                      name: "earlyBirdAmount",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.earlyBirdAmount,
                                      callback: function($$v) {
                                        _vm.earlyBirdAmount = $$v
                                      },
                                      expression: "earlyBirdAmount"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "discount-row-item",
                                  staticStyle: { position: "relative" }
                                },
                                [
                                  _c("date-picker", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            _vm.form.earlyBirdDiscount &&
                                            _vm.form.earlyBirdDiscount.active &&
                                            _vm.discountsOpened,
                                          "future-date": !_vm.validateCampEarlyBirdDiscountExeption
                                        },
                                        expression:
                                          "{\n                                            required: form.earlyBirdDiscount &&form.earlyBirdDiscount.active && discountsOpened,\n                                             'future-date': !validateCampEarlyBirdDiscountExeption\n                                             }"
                                      }
                                    ],
                                    key: "earkyBirdEnds",
                                    staticClass:
                                      "discount-right-tooltiptext-ends",
                                    attrs: {
                                      id: "ends",
                                      info:
                                        "Select last date the discount is available",
                                      name: "earlyBirdEnds",
                                      disabled: !_vm.earlyBirdActive,
                                      label: "Ends"
                                    },
                                    model: {
                                      value: _vm.earlyBirdEndDate,
                                      callback: function($$v) {
                                        _vm.earlyBirdEndDate = $$v
                                      },
                                      expression: "earlyBirdEndDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.futureDate(_vm.earlyBirdEndDate)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "error",
                                          staticStyle: { top: "70px" }
                                        },
                                        [_vm._v("Should be future date")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "discount-wrapper" }, [
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("switch-button", {
                                    attrs: {
                                      label: "Multi child",
                                      id: "multi-child-discount-active",
                                      checked: _vm.multiChildDiscountActive
                                    },
                                    on: {
                                      "update:checked": function($event) {
                                        _vm.multiChildDiscountActive = $event
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "discount-row-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "mt-auto" },
                                  [
                                    _c("select-box", {
                                      key: "multiChildDiscount",
                                      attrs: {
                                        label: "Type",
                                        placeholder: "Select $ or %",
                                        disabled: !_vm.multiChildDiscountActive,
                                        "default-value":
                                          _vm.form.multiChildDiscount &&
                                          _vm.form.multiChildDiscount.bonusType,
                                        "data-list": Object.values(
                                          _vm.BONUS_PAYMENTS_TYPES
                                        ),
                                        required:
                                          _vm.form.multiChildDiscount &&
                                          _vm.form.multiChildDiscount.active &&
                                          _vm.discountsOpened
                                      },
                                      on: {
                                        selected:
                                          _vm.setMultiChildDiscountBonusType
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("app-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            _vm.form.multiChildDiscount &&
                                            _vm.form.multiChildDiscount
                                              .active &&
                                            _vm.discountsOpened,
                                          percentage:
                                            _vm.form.multiChildDiscount &&
                                            _vm.form.multiChildDiscount
                                              .bonusType ===
                                              _vm.BONUS_PAYMENTS_TYPES.RELATIVE,
                                          max: 15,
                                          decimal: 2,
                                          "bigger-or-equal": 0.01
                                        },
                                        expression:
                                          "{\n                                            required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,\n                                            percentage: form.multiChildDiscount && form.multiChildDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,\n                                            max: 15,\n                                            decimal: 2,\n                                            'bigger-or-equal': 0.01\n                                       }"
                                      }
                                    ],
                                    key: "multiChildDiscountAmount",
                                    attrs: {
                                      id: "siblingAmount",
                                      placeholder: "15",
                                      disabled: !_vm.multiChildDiscountActive,
                                      name: "siblingAmount",
                                      label: "Amount Off",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.multiChildDiscountAmount,
                                      callback: function($$v) {
                                        _vm.multiChildDiscountAmount = $$v
                                      },
                                      expression: "multiChildDiscountAmount"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("app-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            _vm.form.multiChildDiscount &&
                                            _vm.form.multiChildDiscount
                                              .active &&
                                            _vm.discountsOpened,
                                          numeric: true,
                                          max: 9
                                        },
                                        expression:
                                          "{\n                                                required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,\n                                                numeric: true,\n                                                max:9\n                                                }"
                                      }
                                    ],
                                    key: "multiChildDiscountAfter",
                                    staticClass: "discount-right-tooltiptext",
                                    attrs: {
                                      id: "after",
                                      placeholder: "2",
                                      info:
                                        "Enter the number of children that need to be<br> enrolled in this camp to receive the discount.",
                                      disabled: !_vm.multiChildDiscountActive,
                                      name: "siblingNumberOfKids",
                                      label: "Discount After",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.multiChildDiscountNumberOfKids,
                                      callback: function($$v) {
                                        _vm.multiChildDiscountNumberOfKids = $$v
                                      },
                                      expression:
                                        "multiChildDiscountNumberOfKids"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "discount-wrapper" }, [
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("switch-button", {
                                    attrs: {
                                      id: "multi-program-discount-active",
                                      label: "Multi program",
                                      checked: _vm.multiProgramDiscountActive
                                    },
                                    on: {
                                      "update:checked": function($event) {
                                        _vm.multiProgramDiscountActive = $event
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("select-box", {
                                    key: "multiProgram",
                                    attrs: {
                                      label: "Type",
                                      placeholder: "Select $ or %",
                                      disabled: !_vm.multiProgramDiscountActive,
                                      "default-value":
                                        _vm.form.multiProgramDiscount &&
                                        _vm.form.multiProgramDiscount.bonusType,
                                      "data-list": Object.values(
                                        _vm.BONUS_PAYMENTS_TYPES
                                      ),
                                      required:
                                        _vm.form.multiProgramDiscount &&
                                        _vm.form.multiProgramDiscount.active
                                    },
                                    on: {
                                      selected:
                                        _vm.setMultiProgramDiscountBonusType
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("app-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            _vm.form.multiProgramDiscount &&
                                            _vm.form.multiProgramDiscount
                                              .active,
                                          percentage:
                                            _vm.form.multiProgramDiscount &&
                                            _vm.form.multiProgramDiscount
                                              .bonusType ===
                                              _vm.BONUS_PAYMENTS_TYPES.RELATIVE,
                                          max: 15,
                                          decimal: 2,
                                          "bigger-or-equal": 0.01
                                        },
                                        expression:
                                          "{\n                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,\n                                            percentage: form.multiProgramDiscount && form.multiProgramDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,\n                                            max: 15,\n                                            decimal: 2,\n                                            'bigger-or-equal': 0.01\n                                       }"
                                      }
                                    ],
                                    key: "multiProgramDiscount",
                                    attrs: {
                                      id: "multiProgramDiscount",
                                      placeholder: "15",
                                      disabled: !_vm.multiProgramDiscountActive,
                                      name: "multiProgramAmount",
                                      label: "Amount Off",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.multiProgramDiscountAmount,
                                      callback: function($$v) {
                                        _vm.multiProgramDiscountAmount = $$v
                                      },
                                      expression: "multiProgramDiscountAmount"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "discount-row-item" },
                                [
                                  _c("app-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required:
                                            _vm.form.multiProgramDiscount &&
                                            _vm.form.multiProgramDiscount
                                              .active,
                                          numeric: true,
                                          max: 9
                                        },
                                        expression:
                                          "{\n                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,\n                                            numeric: true,\n                                            max: 9\n                                            }"
                                      }
                                    ],
                                    key: "multiProgramAfter",
                                    staticClass: "discount-right-tooltiptext",
                                    attrs: {
                                      id: "multiProgramAfter",
                                      info:
                                        "Enter the number of camps a child <br> must be enrolled in to receive the discount",
                                      placeholder: "2",
                                      disabled: !_vm.multiProgramDiscountActive,
                                      name: "multiProgramNumberOfKids",
                                      label: "Discount After",
                                      type: "number"
                                    },
                                    model: {
                                      value:
                                        _vm.multiProgramDiscountNumberOfKids,
                                      callback: function($$v) {
                                        _vm.multiProgramDiscountNumberOfKids = $$v
                                      },
                                      expression:
                                        "multiProgramDiscountNumberOfKids"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  )
                ]
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "step",
        class: {
          "step-closed": !_vm.addOnsOpened,
          disabled: _vm.isCampCostEditingDisabled
        }
      },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c("h2", [_vm._v("Are there any add-ons?")]),
            _vm._v(" "),
            _c("switch-button", {
              attrs: { id: "addons-opened", checked: _vm.addOnsOpened },
              on: {
                "update:checked": function($event) {
                  _vm.addOnsOpened = $event
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.detectIE
          ? [
              _c("transition", { attrs: { name: "expand" } }, [
                _vm.addOnsOpened
                  ? _c(
                      "div",
                      { staticClass: "mg-top-40" },
                      [
                        _vm._l(_vm.addOns, function(addOn) {
                          return _c("add-on", {
                            key: addOn.id,
                            attrs: {
                              "add-on": addOn,
                              required: _vm.addOnsOpened
                            },
                            on: {
                              remove: function($event) {
                                return _vm.removeAddOn(addOn.id)
                              },
                              "input:name": function($event) {
                                return _vm.setAddOnName({
                                  name: $event,
                                  id: addOn.id
                                })
                              },
                              "input:price": function($event) {
                                return _vm.setAddOnPrice({
                                  price: $event,
                                  id: addOn.id
                                })
                              },
                              "input:required": function($event) {
                                return _vm.setAddOnRequired({
                                  required: $event,
                                  id: addOn.id
                                })
                              },
                              "input:max-amount": function($event) {
                                return _vm.setAddOnMaxAmount({
                                  maxAmount: $event,
                                  id: addOn.id
                                })
                              }
                            }
                          })
                        }),
                        _vm._v(" "),
                        _c(
                          "add-button",
                          {
                            staticClass: "add-button",
                            on: { click: _vm.addNewAddOn }
                          },
                          [
                            _vm._v(
                              "\n                            Addon\n                        "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ]
          : [
              _c(
                "transition",
                {
                  attrs: { name: "expand" },
                  on: {
                    enter: _vm.onEnter,
                    "after-enter": _vm.onAfterEnter,
                    leave: _vm.onLeave
                  }
                },
                [
                  _vm.addOnsOpened
                    ? _c(
                        "div",
                        { staticClass: "mg-top-40" },
                        [
                          _vm._l(_vm.addOns, function(addOn) {
                            return _c("add-on", {
                              key: addOn.id,
                              attrs: {
                                "add-on": addOn,
                                required: _vm.addOnsOpened
                              },
                              on: {
                                remove: function($event) {
                                  return _vm.removeAddOn(addOn.id)
                                },
                                "input:name": function($event) {
                                  return _vm.setAddOnName({
                                    name: $event,
                                    id: addOn.id
                                  })
                                },
                                "input:price": function($event) {
                                  return _vm.setAddOnPrice({
                                    price: $event,
                                    id: addOn.id
                                  })
                                },
                                "input:required": function($event) {
                                  return _vm.setAddOnRequired({
                                    required: $event,
                                    id: addOn.id
                                  })
                                },
                                "input:max-amount": function($event) {
                                  return _vm.setAddOnMaxAmount({
                                    maxAmount: $event,
                                    id: addOn.id
                                  })
                                }
                              }
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "add-button",
                            {
                              staticClass: "add-button",
                              on: { click: _vm.addNewAddOn }
                            },
                            [
                              _vm._v(
                                "\n                            Addon\n                        "
                              )
                            ]
                          )
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            ]
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step", class: { "step-closed": !_vm.detailsOpened } },
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c("h2", [_vm._v("Are other details needed?")]),
            _vm._v(" "),
            _c("switch-button", {
              attrs: { id: "details-opened", checked: _vm.detailsOpened },
              on: {
                "update:checked": function($event) {
                  _vm.detailsOpened = $event
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.detectIE
          ? [
              _c("transition", { attrs: { name: "expand" } }, [
                _vm.detailsOpened
                  ? _c("div", { staticClass: "mg-top-40 mg-right-150" }, [
                      _c(
                        "div",
                        { staticClass: "mg-top-40" },
                        [
                          _c("select-box", {
                            attrs: {
                              label: "Choose question form",
                              "multiple-select": true,
                              "chip-width": _vm.chipWidth,
                              "show-all-item": false,
                              "data-list": _vm.customForms,
                              "format-callback": function(form) {
                                return form.formName
                              },
                              "default-value": _vm.defaultCustomForms,
                              required: false
                            },
                            on: {
                              selected: function($event) {
                                return _vm.selectedForm($event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "checkbox",
                            {
                              staticClass: "step3-checkbox",
                              attrs: { checked: _vm.pickUpOptions },
                              on: {
                                "update:checked": function($event) {
                                  _vm.pickUpOptions = $event
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Pickup Options\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "checkbox",
                            {
                              staticClass: "step3-checkbox",
                              attrs: {
                                checked: _vm.pickUpOptionsRequired,
                                disabled: !_vm.pickUpOptions
                              },
                              on: {
                                "update:checked": function($event) {
                                  _vm.pickUpOptionsRequired = $event
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Required\n                            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "checkbox",
                            {
                              staticClass: "step3-checkbox",
                              attrs: { checked: _vm.teacher },
                              on: {
                                "update:checked": function($event) {
                                  _vm.teacher = $event
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Homeroom Teacher\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "checkbox",
                            {
                              staticClass: "step3-checkbox",
                              attrs: {
                                checked: _vm.teacherRequired,
                                disabled: !_vm.teacher
                              },
                              on: {
                                "update:checked": function($event) {
                                  _vm.teacherRequired = $event
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Required\n                            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "checkbox",
                            {
                              attrs: { checked: _vm.tshirt },
                              on: {
                                "update:checked": function($event) {
                                  _vm.tshirt = $event
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                T-shirt size\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "checkbox",
                            {
                              attrs: {
                                checked: _vm.tshirtRequired,
                                disabled: !_vm.tshirt
                              },
                              on: {
                                "update:checked": function($event) {
                                  _vm.tshirtRequired = $event
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                Required\n                            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            ]
          : [
              _c(
                "transition",
                {
                  attrs: { name: "expand" },
                  on: {
                    enter: _vm.onEnter,
                    "after-enter": _vm.onAfterEnter,
                    leave: _vm.onLeave
                  }
                },
                [
                  _vm.detailsOpened
                    ? _c("div", { staticClass: "mg-top-40 mg-right-150" }, [
                        _c(
                          "div",
                          { staticClass: "mg-top-40" },
                          [
                            _c("select-box", {
                              attrs: {
                                label: "Choose question form",
                                "multiple-select": true,
                                "chip-width": _vm.chipWidth,
                                "show-all-item": false,
                                "data-list": _vm.customForms,
                                "format-callback": function(form) {
                                  return form.formName
                                },
                                "default-value": _vm.defaultCustomForms,
                                required: false
                              },
                              on: {
                                selected: function($event) {
                                  return _vm.selectedForm($event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c(
                              "checkbox",
                              {
                                staticClass: "step3-checkbox",
                                attrs: { checked: _vm.pickUpOptions },
                                on: {
                                  "update:checked": function($event) {
                                    _vm.pickUpOptions = $event
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Pickup Options\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                staticClass: "step3-checkbox",
                                attrs: {
                                  checked: _vm.pickUpOptionsRequired,
                                  disabled: !_vm.pickUpOptions
                                },
                                on: {
                                  "update:checked": function($event) {
                                    _vm.pickUpOptionsRequired = $event
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Required\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c(
                              "checkbox",
                              {
                                staticClass: "step3-checkbox",
                                attrs: { checked: _vm.teacher },
                                on: {
                                  "update:checked": function($event) {
                                    _vm.teacher = $event
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Homeroom Teacher\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                staticClass: "step3-checkbox",
                                attrs: {
                                  checked: _vm.teacherRequired,
                                  disabled: !_vm.teacher
                                },
                                on: {
                                  "update:checked": function($event) {
                                    _vm.teacherRequired = $event
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Required\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _c(
                              "checkbox",
                              {
                                attrs: { checked: _vm.tshirt },
                                on: {
                                  "update:checked": function($event) {
                                    _vm.tshirt = $event
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                T-shirt size\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "checkbox",
                              {
                                attrs: {
                                  checked: _vm.tshirtRequired,
                                  disabled: !_vm.tshirt
                                },
                                on: {
                                  "update:checked": function($event) {
                                    _vm.tshirtRequired = $event
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Required\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43762310", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43762310","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camp-form/Step4.vue
// module id = null
// module chunks = 